import './App.css';
import LogIn from './pages/login/LogIn.js';
import SignUp from './pages/signUp/SignUp.js';
import Notification from './pages/notification/Notification.js';
import ApproveOrDenyRequest from './pages/approveordenyrequest/ApproveOrDenyRequest.js';
import SearchFilter from './pages/searchFilter/SearchFilter.js';
import Home from './pages/home/Home.js';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header.js';
import PlayerList from './pages/playerList/PlayerList.js';
import PlayerProfile from './pages/playerProfile/PlayerProfile.js';
import GameList from './pages/gamelist/GameList.js';
import FilterPage from './pages/filterpage/FIlterPage.js';
import GameDetails from './pages/gamedetails/GameDetails.js';
import ForgetPassword from './pages/forgetpassword/ForgetPassword.js';
import ConfirmationCode from './pages/confirmatoncode/ConfirmationCode.js';
import CreateNewPassword from './pages/createnewpassword/CreateNewPassword.js';
import SuccessPage from './pages/successpage/SuccessPage.js';
import { useState } from 'react';
import SignUpConfirmationCode from './pages/signupconfirmationcode/SignUpConfirmationCode.js';
import { toast, ToastContainer } from 'react-toastify';
import CustomHeader from './components/CustomHeader.js';
import SportsExperience from './pages/personalise/SportExperience.js';
import AvatarName from './pages/personalise/AvatarName.js';
import Location from './pages/personalise/Location.js';
import SubscriptionPlan from './pages/personalise/SubscriptionPlan.js';
import MyGame from './pages/myGame/myGame.js';
import MyGameJoined from './pages/mygamejoined/MyGameJoined.js';
import LeaveGameModal from './components/LeaveGame.js';
import Games from './pages/games/Games.js';
import CreatedGames from './pages/createdgames/CreatedGames.js';
import JoinedPlayerList from './pages/joinedplayerlist/JoinedPlayerList.js';
import InvitePlayer from './pages/Inviteplayer/InvitePlayer.js';
import GameSearchFilter from './pages/gamesearchfilter/GameSearchFilter.js';
import ProfilePlayer from './pages/profileplayer/ProfilePlayer.js';
import EditProfile from './pages/edit-profile/EditProfile.js';
import CreateGame from './pages/creategame/CreateGame.js';
import NotificationSettings from './pages/profile/NotificationSetting.js';
import ChooseLanguage from './pages/profile/ChooseLanguage.js';
import MembershipDetail from './pages/profile/MemberShipDetail.js';
import ContactUs from './pages/profile/ContactUs.js';
import DeleteYourAccount from './pages/profile/DeleteYourAccount.js';
import YourSports from './pages/profile/YourSports.js';
import PaymentHistory from './pages/profile/PaymentHistory.js';
import PlayersList from './pages/profile/PlayerList.js';
import AcountPopUp from './components/AccountPopUp.js';
import InvitePLayerList from './pages/profile/InvitePlayerList.js';
import ChatBox from './pages/chat/ChatBox.js';
import ChatPerson from './pages/chat/ChatPerson.js';
import ErrorPage from './components/ErrorPage.js';
import { useLocation } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRouter.js';
import { useSelector } from 'react-redux';
import Stringer from './pages/stringer/Stringer.js';
import FindPlayer from './pages/findPlayer/FindPlayer.js';
import CreateGamePaymentWrapper from './pages/personalise/CreateGanmePaymentWrapper.js';
import StripePayment from './pages/personalise/SripePayment.js';
import NotificationSocketListener from './pages/notification/NotificationSocketListener.js';
import { useEffect } from 'react';

import { GoogleOAuthProvider } from '@react-oauth/google';
import ChooseAvatar from './pages/profile/ChooseAvtar.js';
import RequestedToJoinList from './pages/notification/RequestedToJoinList.js';
import Callback from './pages/oauth/callback.js';
import { Navigate } from 'react-router-dom';
import GameSocketListener from './pages/gamelist/GameSocketListener.js';
import AutoLogOut from './components/AutoLogOut.js';
import FindPlayerSocket from './pages/findPlayer/FindPlayerSocket.js';
import PrivacyAndPolicy from './pages/home/privacyAndPolicy.js';
import TermAndCondition from './pages/home/TermAndCondition.js';
import DeleteProcessPage from './pages/home/deletePage.js';
import { apiHandler } from './assets/api/index.js';
import { endpoint } from './assets/api/endpoint.js';



function App() {
  const [loggedIn, setIsLoggedIn] = useState();
  const { accessToken } = useSelector((state) => state.loginInfo);

  const onLogIn = (data) => {
    // setIsLoggedIn(data);
  }



  const isAuthenticated = accessToken?.accessToken ?? false;

  useEffect(() => {
    if ('caches' in window) {
      caches.keys().then(names => {
        for (let name of names) caches.delete(name);
      });
    }
  }, []);

  const clientId = '332654565913-llp0fuljm03it6illsrudfds8c9qcqjo.apps.googleusercontent.com'
  return (
    <GoogleOAuthProvider clientId={clientId}>
      <div className="App">
        <Router>
          <ToastContainer />
          <HeaderWithLocation isAuthenticated={isAuthenticated} />
          <NotificationSocketListener />
          <GameSocketListener />
          <FindPlayerSocket />
          <Routes>
            <Route path="/privacy-policy" element={<PrivacyAndPolicy/>} />
            <Route path="/term-condition" element={<TermAndCondition />} />
            <Route path="/about-delete" element={<DeleteProcessPage />} />
             <Route path="/register" element={<SignUp />} />
            {!isAuthenticated &&
              <>
                <Route path="/login" element={<LogIn onLogIn={onLogIn} />} />
                <Route path="/register" element={<SignUp />} />
                <Route path="/register/login" element={<SignUp />} />
                <Route path="/signupconfirmcode" element={< SignUpConfirmationCode />} />
                <Route path="/sendotp" element={<ConfirmationCode />} />

                <Route path="/" element={< Home />} />
                <Route path="/forget-password" element={<ForgetPassword />} />
                <Route path="/create-new-password" element={<CreateNewPassword />} />
                <Route path="/oauth/callback" element={<Callback />} />
              </>
            }
            {/* <Route path="/login" element={   isAuthenticated ? <Navigate to="/explore" /> : <Navigate to="/login" /> }/> */}
            <Route element={<ProtectedRoute isAuthenticated={isAuthenticated} />}>
              <Route path="/notification" element={<Notification />} />
              <Route path="/explore" element={<GameList />} />
              <Route path="/your-games" element={<Games />} />
              <Route path="/joined-games" element={<MyGame />} />
              <Route path="/hosted-games" element={<CreatedGames />} />
              <Route path="/" element={<Callback />} />
              <Route path="/game-details/:gameId" element={<GameDetails />} />
              <Route path="/games/gamedetail/:gameId" element={<GameDetails />} />
              <Route path="/creategame" element={<CreateGame />} />
              <Route path="/games/filter" element={<FilterPage />} />
              <Route path="/mygame" element={<MyGame />} />
              <Route path="/mygamejoined/:gameId" element={<MyGameJoined />} />
              <Route path="/createdgame" element={<CreatedGames />} />
              <Route path="/invite-player" element={<InvitePlayer />} />
              <Route path="/game-search-filter" element={<GameSearchFilter />} />
              <Route path="/findplayer" element={<FindPlayer />} />
              <Route path="/joinedplayerlist" element={<JoinedPlayerList />} />
              <Route path="/games/filter/gamedetail/mygame/mygamejoined/leavegame" element={<LeaveGameModal />} />
              <Route path="/games/filter/gamedetail/mygame/mygamejoined/leavegame" element={<LeaveGameModal />} />
              <Route path="/profile/players-list/invite-player" element={<InvitePLayerList />} />
              <Route path="/profile" element={<ProfilePlayer />} />
              <Route path="/profile/edit-profile" element={<EditProfile />} />
              <Route path="/profile/notification" element={<NotificationSettings />} />
              <Route path="/profile/language" element={<ChooseLanguage />} />
              <Route path="/choose-avatar" element={<ChooseAvatar />} />
              <Route path="/profile/membership-detail" element={<MembershipDetail />} />
              <Route path="/profile/payment-history" element={<PaymentHistory />} />
              <Route path="/profile/contact-us" element={<ContactUs />} />
              <Route path="/profile/account-pop-up" element={<AcountPopUp />} />
              <Route path="/delete-your-account" element={<DeleteYourAccount />} />
              <Route path="/profile/your-sports" element={<YourSports />} />
              <Route path="/profile/players-list" element={<PlayersList />} />
              <Route path="/games/joined-player-list" element={<JoinedPlayerList />} />
              <Route path="/stringer" element={<Stringer />} />
              <Route path="/playerprofile" element={<PlayerProfile />} />
              <Route path="/personalise" element={<AvatarName />} />
              <Route path="/sportexperience" element={<SportsExperience />} />
              <Route path="/location" element={<Location />} />
              <Route path="/subscription" element={<SubscriptionPlan />} />
              <Route path="/create-game-payment" element={<CreateGamePaymentWrapper />} />
              <Route path="/meetfriends" element={< SearchFilter />} />
              <Route path="notification/approveordenyrequest" element={< ApproveOrDenyRequest />} />
              <Route path="/approveordenyrequest" element={< ApproveOrDenyRequest />} />
              <Route path="/requested-to-join-list" element={<RequestedToJoinList />} />
              <Route path="/profile/player-list" element={<PlayerList />} />
              <Route path="/meetfriends/playerlist/playerprofile" element={<PlayerProfile />} />
              <Route path="/forgetpassword" element={<ForgetPassword />} />
              <Route path="/forgetpassword/sendotp" element={<ConfirmationCode />} />
              <Route path="/createnewpassword" element={<CreateNewPassword />} />
              <Route path="/success" element={<SuccessPage />} />
              <Route path="/forgetpassword/register" element={<SignUp />} />
              <Route path="/chat" element={<ChatBox />} />
              <Route path="/stripe-payment" element={<StripePayment />} />
              <Route path="/chat/chat-person" element={<ChatPerson />} />
            </Route>
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </Router>
      </div>
    </GoogleOAuthProvider>
  );
}
const HeaderWithLocation = ({ isAuthenticated }) => {
  const location = useLocation();

  return (
    <>
      {(location.pathname !== '/login' &&
        location.pathname !== '/register' &&
        location.pathname !== '/forget-password') &&
        location.pathname !== '/sendotp' &&
        location.pathname !== '/create-new-password' &&
        location.pathname !== '/signupconfirmcode' &&
        location.pathname !== '/personalise' &&
        location.pathname !== '/location' &&
        location.pathname !== '/sportexperience' &&
        location.pathname !== '/subscription' &&
        location.pathname !== '/privacy-policy' &&
        location.pathname !== '/term-condition' &&
        location.pathname !== '/about-delete' &&
        <div className='header-container'>
          <CustomHeader loggedIn={isAuthenticated} />
        </div>
      }
      <AutoLogOut />
    </>
  );
}



export default App;
